

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faLinkedin,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../images/MAAMAAS_LOGO_V1-01[1].png";

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="row">
          {/* Quick Links */}
          <div className="col">
            <div className="heading">Quick Links</div>
            <div className="detail"><a href="#who-we-are">Who We Are</a></div>
            <div className="detail"><a href="#what-we-do">What We Do</a></div>
            <div className="detail"><a href="#contact">Contact</a></div>
          </div>

          {/* Get In Touch */}
          <div className="col">
            <div className="heading">Get In Touch</div>
            <div className="detail">
              {/* <FontAwesomeIcon icon={faEnvelope} className="icon" /> */}
              📧 info@maamaas.com
            </div>
            <div className="detail">
              {/* <FontAwesomeIcon icon={faPhone} className="icon" /> */}
              📞 9063906314
            </div>
          </div>

          {/* Social Media */}
          <div className="col">
            <div className="heading">Follow Us</div>
            <div className="s-social">
              <a
                href="https://www.facebook.com/share/14StDBCZdj5/"
                target="_blank"
                rel="noopener noreferrer" ><FontAwesomeIcon icon={faFacebook} /></a>
              <a
                href="https://www.linkedin.com/in/maamaas-house-282760306/"
                target="_blank"
                rel="noopener noreferrer" ><FontAwesomeIcon icon={faLinkedin} /></a>
              <a
                href="https://www.instagram.com/maamaashouse?igsh=YnZhajZ0MWRydTMz"
                target="_blank"
                rel="noopener noreferrer" ><FontAwesomeIcon icon={faInstagram} /></a>
              <a
                href="https://www.youtube.com/@MAAMAASHOUSE"
                target="_blank"
                rel="noopener noreferrer" ><FontAwesomeIcon icon={faYoutube} /></a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <img src={logo} alt="logo" className="logo" />
          <p>
            Copyright © 2025{" "}
            <span className="brand-name">MAAMAA'S </span>, LLC. All Rights Reserved.
          </p>
        </div>
      </div>

      {/* Internal CSS */}
      <style>{`
        .footer-container {
          background-color: #2a0947;
          padding: 30px 20px;
          color: white;
          font-family: Roboto, sans-serif;
          margin-top:30px;
        }
        .row {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }
        .col {
          flex: 1;
          min-width: 200px;
          margin: 10px 0;
        }
        .heading {
          color: rgb(255, 225, 36);
          font-weight: bold;
          font-size: 23px;
          margin-bottom: 10px;
        }
        .detail {
          margin-bottom: 8px;
          color: white;
          font-size:20px;
          font-weight:bold;
        }
        .detail a {
          text-decoration: none;
          color: white;
          font-size:20px;
          font-weight:bold;
        }
        .detail a:hover {
          color: rgb(255, 225, 36);
        }
        .icon {
          margin-right: 10px;
        }
        .s-social a {
          color: white;
          font-size: 25px;
           font-weight:bold;
          margin-right: 15px;
          transition: 0.3s;
        }
        .s-social a:hover {
          color: rgb(255, 225, 36);
        }
        .footer-bottom {
          border-top: 1px solid #444;
          padding-top: 15px;
          text-align: center;
          font-weight:bold;
           font-size:20px;
        }
        .logo {
          height: 50px;
          margin-bottom: 10px;
        }
        .brand-name {
          font-family: "Raqupine Regular", sans-serif;
          color: rgb(255, 225, 36);
           font-weight:bold;
           font-size:20px;
        }
      `}</style>
    </footer>
  );
};

export default Footer;

